module.exports = __webpack_public_path__ + "img/U1F328.52035d52.png";